import { render, staticRenderFns } from "./BaseJinNangTable.vue?vue&type=template&id=0785eee3&scoped=true&"
import script from "./BaseJinNangTable.vue?vue&type=script&lang=js&"
export * from "./BaseJinNangTable.vue?vue&type=script&lang=js&"
import style0 from "./BaseJinNangTable.vue?vue&type=style&index=0&id=0785eee3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0785eee3",
  null
  
)

export default component.exports